import { requests } from '..';
import { sessionRepository } from '../session';
import { OrganizationRepositoryApi } from './OrganizationRepositoryApi';

export const organizationRepository = new OrganizationRepositoryApi(requests, sessionRepository);
